import { mergeStyles } from "@fluentui/react";

export const homeGrid = mergeStyles({
    display: "block"
  });

export const separator = mergeStyles({
    height: "10em",
});
